import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

NumberSteps.propTypes = {
    children: PropTypes.node.isRequired,
    onIncrement: PropTypes.func.isRequired,
    onDecrement: PropTypes.func.isRequired,
    incrementTitle: PropTypes.string,
    decrementTitle: PropTypes.string,
    decrementDisabled: PropTypes.bool,
    incrementDisabled: PropTypes.bool,
    disabled: PropTypes.bool,
};

NumberSteps.defaultProps = {
    decrementDisabled: false,
    incrementDisabled: false,
    incrementTitle: null,
    decrementTitle: null,
    disabled: false,
};

function NumberSteps(props) {
    const {
        children,
        onIncrement,
        onDecrement,
        incrementTitle,
        decrementTitle,
        decrementDisabled,
        incrementDisabled,
        disabled,
    } = props;
    return (
        <>
            <button
                type="button"
                aria-label="-"
                className="decrement-button button-bordered button-small"
                title={decrementTitle}
                disabled={disabled || decrementDisabled}
                onClick={onDecrement}
                tabIndex={-1}
            >
                <FontAwesomeIcon icon="minus" />
            </button>
            {children}
            <button
                type="button"
                aria-label="+"
                className="increment-button button-bordered button-small"
                title={incrementTitle}
                disabled={disabled || incrementDisabled}
                onClick={onIncrement}
                tabIndex={-1}
            >
                <FontAwesomeIcon icon="plus" />
            </button>
        </>
    );
}

export default NumberSteps;
